export default __webpack_public_path__ + "static/media/diver.db9a0648.png";